"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    isEligible: function() {
        return isEligible;
    },
    isUpsellApplicable: function() {
        return isUpsellApplicable;
    }
});
var _fp = require("lodash/fp");
var _constants = require("@ahmdigital/constants");
var _getproducttypefromproductid = /*#__PURE__*/ _interop_require_default(require("../../utils/get-product-type-from-product-id"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var isPackageOrCombined = function(productType) {
    return (0, _fp.includes)(productType, [
        _constants.PRODUCT_TYPE.PACKAGE,
        _constants.PRODUCT_TYPE.COMBINED
    ]);
};
var isEligible = function() {
    var productId = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).productId;
    if (!productId) return false;
    var productType = (0, _getproducttypefromproductid.default)(productId);
    return isPackageOrCombined(productType);
};
var isUpsellApplicable = function() {
    var productId = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).productId;
    if (!productId) return false;
    var productType = (0, _getproducttypefromproductid.default)(productId);
    return !isPackageOrCombined(productType);
};
